import { Slider, SliderThumb, Typography, styled } from '@mui/material'
import PropTypes from 'prop-types'
import { useState } from 'react'

const StyledSlider = styled(Slider)(({ theme }) => ({
  color: 'transparent',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 37,
    width: 68,
    color: '#fff',
    backgroundColor: '#3C4FB9',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    borderRadius: '4px',
  },
  '& .MuiSlider-track': {
    height: 5,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? 'red' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 7,
  },
}))

const ExpirySlider = ({ value, setValue }) => {
  function ThumbComponent(props) {
    const { children, ...other } = props
    return (
      <SliderThumb {...other}>
        {children}
        <Typography fontSize={'12px'} textAlign={'center'}>
          {value} days
        </Typography>
      </SliderThumb>
    )
  }

  ThumbComponent.propTypes = {
    children: PropTypes.node,
  }

  return (
    <StyledSlider
      slots={{ thumb: ThumbComponent }}
      getAriaLabel={(index) => (index === 0 ? 'Minimum price' : 'Maximum price')}
      defaultValue={20}
      value={Number(value)}
      onChange={(e, v) => {
        setValue(Number(v))
      }}
      min={1}
      max={60}
    />
  )
}

export default ExpirySlider
